import React from 'react';
import moment from "moment";
import { Trans } from 'react-i18next';

import {GridContainer, GridItem} from '../../../../../Common/DesignSystem/Grid';
import { P3, Heading6, InputLabel } from '../../../../../Common/DesignSystem/Text';
import colours from '../../../../../Common/DesignSystem/Colours';
import { DropdownItem, Input } from '../../../../../Common/DesignSystem/Input';
import i18n from '../../../../../../i18n';
import FileUploadCard from '../../../../../Common/DesignSystem/FileUploadCard';

// TODO: refactor this component removing unnecessary duplicated components like the FileUploadCard, it should handle responsiveness without duplicating code

export const VehicleInfoCard = ({ vehicleForm, windowWidth, updateSelect, updateVehicleForm, inputRefs, isCreatingVehicle, fileInputRef, fileDropRef, uploadImage, loadingImage, imageThumbnail, imageName, editingVehicleImage }) => (
	<div className="overlay_header_bordered" style={{flexGrow: 0}}>
		<GridContainer justifyContent="space-evenly" spacing={3} direction="row">
			<GridItem xs={windowWidth <= 768 ? 12 : 6}>
				{windowWidth <= 768 ? (
					<div style={{flex: 1, display: 'flex', flexDirection: 'column', marginTop: 32}}>
						<Heading6>
							{`${vehicleForm.year || ''} ${vehicleForm.make || ''} ${vehicleForm.model || ''} ${vehicleForm.trim || ''}`}
						</Heading6>
						<P3 style={{color: colours.primary.grey02, marginTop: 8}}>
							{vehicleForm.vin}
						</P3>
					</div>
				) : (
					<>
						<div className="ds-input-label" style={{marginLeft: 16, marginBottom: 4,  display: 'flex', flexDirection: 'row'}}>
							<InputLabel>{i18n.t('Vehicle Image')}</InputLabel>
						</div>
						{imageThumbnail && (
							<p style={{ color: 'red', fontSize: '12px', padding: '10px 0'}}>
								<Trans>* Please save the form to save this uploaded image</Trans>
							</p>
						)}
						<div style={{display: 'flex', flex: 1, flexDirection: 'row'}}>
							<FileUploadCard
								imageSrc={imageThumbnail || editingVehicleImage || null}
								imageName={imageThumbnail ? imageName : ''}
								accept="image/png, image/jpeg"
								uploadText="Add Vehicle Image or Drop Here"
								inputRef={fileInputRef}
								dropRef={fileDropRef}
								replaceClick={() => fileInputRef.current.click()}
								handleUpload={uploadImage}
								loading={loadingImage}
							/>
						</div>
					</>
				)}
			</GridItem>
			<GridItem xs={windowWidth <= 768 ? 12 : 6}>
				{windowWidth <= 768 ? (
					<>
						<div className="ds-input-label" style={{marginLeft: 16, marginBottom: 4,  display: 'flex', flexDirection: 'row'}}>
							<InputLabel>{i18n.t('Vehicle Image')}</InputLabel>
						</div>
						{imageThumbnail && (
							<p style={{ color: 'red', fontSize: '12px', padding: '10px 0'}}>
								<Trans>* Please save the form to save this uploaded image</Trans>
							</p>
						)}
						<div style={{display: 'flex', flex: 1, flexDirection: 'row'}}>
							<FileUploadCard
								imageSrc={imageThumbnail || editingVehicleImage || null}
								imageName={imageThumbnail ? imageName : ''}
								accept="image/png, image/jpeg"
								uploadText="Add Vehicle Image or Drop Here"
								inputRef={fileInputRef}
								dropRef={fileDropRef}
								replaceClick={() => fileInputRef.current.click()}
								handleUpload={uploadImage}
								loading={loadingImage}
							/>
						</div>
					</>
				) : (
					<div style={{flex: 1, display: 'flex', flexDirection: 'column', marginTop: 32}}>
						<Heading6>
							{`${vehicleForm.year || ''} ${vehicleForm.make || ''} ${vehicleForm.model || ''} ${vehicleForm.trim || ''}`}
						</Heading6>
						<P3 style={{color: colours.primary.grey02, marginTop: 8}}>
							{vehicleForm.vin}
						</P3>
					</div>
				)}
			</GridItem>
		</GridContainer>
		<div style={{display: 'flex', flexDirection: 'row', flex: windowWidth <= 768 ? 2 : 4, marginTop: 16, marginBottom: 16, borderBottom: `solid 1px ${colours.primary.grey04}`, flexWrap: 'wrap'}}>
			<div className="half-width-mr f1 mr-24">
				<Input label="Year" name="year" dropdown required value={vehicleForm.year} onChange={(e)=> {updateSelect({name: 'year', value: e.currentTarget.dataset.id})}}>
					{Array.from(new Array(10), (val, index)=> index).map((index) => (
						<DropdownItem label={moment().add(2, 'years').format("YYYY") - index} value={moment().add(2, 'years').format("YYYY") - index}/>
					))}
				</Input>
			</div>
			<div className="half-width f1 mr-24">
				<Input label="Make" name="make" required value={vehicleForm.make} onChange={updateVehicleForm}/>
			</div>
			<div className="half-width-mr f1 mr-24">
				<Input label="Model" name="model" required value={vehicleForm.model} onChange={updateVehicleForm}/>
			</div>
			<div className="half-width f1">
				<Input label="Trim" name="trim" value={vehicleForm.trim} onChange={updateVehicleForm}/>
			</div>
		</div>
		<GridContainer justifyContent="space-evenly" spacing={windowWidth <= 768 ? 0 : 3} direction={windowWidth <= 768 ? "column" : "row"}>
			<GridItem xs={windowWidth <= 768 ? 12 : 5} style={{borderRight: windowWidth <= 768 ? '' : `solid 1px ${colours.primary.grey04}`, borderBottom: windowWidth <= 768 ? `solid 1px ${colours.primary.grey04}` : ''}}>
				<div style={{flex: 1}}>
					<Input label="VIN" required name="vin" value={vehicleForm.vin} onChange={updateVehicleForm}/>
				</div>
				<div style={{flex: 1}}>
					<Input label="License Plate" name="plate" value={vehicleForm.plate} onChange={updateVehicleForm}/>
				</div>
				<div style={{flex: 1}}>
					<Input label="Unique Tag" placeholder="TAG12345" name="tag" value={vehicleForm.tag} onChange={updateVehicleForm}/>
				</div>
			</GridItem>
			<GridItem container xs={windowWidth <= 768 ? 12 : 7} direction="row" spacing={0}>
				<GridContainer direction="row" spacing={3}>
					<GridItem xs={windowWidth <= 768 ? 6 : 8} style={{marginTop: windowWidth <= 768 ? 16 : 0}}>
						<div>
							<Input
								label="Mileage"
								name="km"
								readOnly={!isCreatingVehicle}
								value={vehicleForm.km}
								onChange={updateVehicleForm}
								trailing_ic="KM"
								trailing_ic_rawText
							/>
						</div>
					</GridItem>
					<GridItem xs={windowWidth <= 768 ? 6 : 4} style={{marginTop: windowWidth <= 768 ? 16 : 0}}>
						<Input label="Keys" name="keys" value={vehicleForm.keys} onChange={updateVehicleForm}/>
					</GridItem>
				</GridContainer>
				<GridItem xs={12}>
					<div className="f1">
						<Input label="Exterior Colour" name="exterior_exact_color" value={vehicleForm.exterior_exact_color} onChange={updateVehicleForm} ref={inputRefs.exteriorColourRef}/>
					</div>
				</GridItem>
				<GridItem xs={12}>
					<div className="f1">
						<Input label="Interior Colour" name="interior_exact_color" value={vehicleForm.interior_exact_color} onChange={updateVehicleForm} ref={inputRefs.interiorColourRef}/>
					</div>
				</GridItem>
			</GridItem>
		</GridContainer>
	</div>
);